import { useQuery } from "@tanstack/react-query";
import { researchCms } from "@/api/researchCms.service";
import { type SplitCardInput, readSplitCardsFromUrl } from "../utils/bpaSplit";
import type { ImportPurpose } from "../utils/bpaImportUrlState";

export type SplitImportContext = {
  otherCardMoved: boolean;
  otherName: string | null;
};

const URL_BASE = "http://hub.invalid";

function otherCardOf(hub: string, targetEditionBpaId: string): SplitCardInput | null {
  const cards = readSplitCardsFromUrl(new URL(hub, URL_BASE).searchParams);
  return cards.find(card => card.editionBpaId && card.editionBpaId !== targetEditionBpaId) ?? null;
}

export function useSplitImportContext(input: {
  purpose: ImportPurpose | null;
  hub: string | null;
  originalEditionBpaId: string | null;
  targetEditionBpaId: string | null;
}): SplitImportContext | null {
  const { purpose, hub, originalEditionBpaId, targetEditionBpaId } = input;
  const isSplit = purpose === "split" && !!hub && !!originalEditionBpaId && !!targetEditionBpaId;
  const otherCard = isSplit ? otherCardOf(hub, targetEditionBpaId) : null;
  const otherId = otherCard?.editionBpaId ?? null;
  const history = useQuery({
    queryKey: ["bpa-import-history", otherId],
    queryFn: () => researchCms.getImportHistory(otherId as string),
    enabled: isSplit && otherId !== null,
  });
  if (!isSplit) return null;
  if (otherId === null) return { otherCardMoved: false, otherName: null };
  if (!history.isSuccess) return null;
  const otherCardMoved = history.data.importHistory.some(
    item => item.purpose === "split" && item.sourceEditionBpaId === originalEditionBpaId,
  );
  return { otherCardMoved, otherName: otherCard?.name ?? null };
}
